import { useContext } from 'react';

import { useAnalytics } from '@/hooks/analytics';
import { useRouterPush } from '@/hooks/utils/useRouterPush';

import { PreSignupFlowContext } from '../../PreSignupProvider';
import { Wrapper } from './styles';

const BackButton = () => {
	const { previousScreen, ActiveScreen } = useContext(PreSignupFlowContext);
	const { analyticsName, questionType, transitionType, backButtonHidden, isDark } = ActiveScreen;
	const { logEvent } = useAnalytics();
	const routerPush = useRouterPush();
	const isLandingScreen = ['TransitionScreen', 'WelcomeScreen'].includes(ActiveScreen.componentName);

	if (backButtonHidden) return null;

	const onClick = async (): Promise<void> => {
		logEvent({
			eventName: `${analyticsName} : Back : Tapped`,
			eventProps: {
				...(questionType ? { question_type: questionType } : {}),
				...(transitionType ? { transition_type: transitionType } : {}),
			},
		});
		window.scrollTo(0, 0);

		if (isLandingScreen) {
			const redirectUrl = document.referrer.split('?')[0];
			await routerPush(redirectUrl);
		} else {
			previousScreen();
		}
	};

	return <Wrapper onPress={onClick} $isWhite={isDark} aria-label="back" />;
};

export default BackButton;
